import React from "react";

const IncloudIcon = ({ width = "16px" }) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={width}
    viewBox="0 0 48 31"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="0.297"
        y1="0.044"
        x2="0.629"
        y2="1.022"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#2aa4f4" />
        <stop offset="1" stop-color="#007ad9" />
      </linearGradient>
    </defs>
    <g id="Grupo_2" data-name="Grupo 2" transform="translate(-936 -525)">
      <g id="icons8-download-from-the-cloud" transform="translate(936 518)">
        <path
          id="Trazado_1"
          data-name="Trazado 1"
          d="M48,26A12,12,0,0,1,36,38H9.5A9.5,9.5,0,0,1,7.45,19.22a16.006,16.006,0,0,1,28.79-5.21A11.984,11.984,0,0,1,48,26Z"
          fill="url(#linear-gradient)"
        />
        <path
          id="Trazado_3"
          data-name="Trazado 3"
          d="M26.5,25.5V18A1.5,1.5,0,0,0,25,16.5H23A1.5,1.5,0,0,0,21.5,18v7.5H18.479a1.053,1.053,0,0,0-.745,1.8l5.129,5.13a1.606,1.606,0,0,0,2.271,0l5.129-5.13a1.053,1.053,0,0,0-.745-1.8Z"
          transform="matrix(-1, 0.017, -0.017, -1, 48.425, 48.976)"
          opacity="0.07"
        />
        <g
          id="Grupo_1"
          data-name="Grupo 1"
          transform="translate(48.428 48.997) rotate(179)"
        >
          <path
            id="Trazado_2"
            data-name="Trazado 2"
            d="M27,25V18a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v7H18.352a1.5,1.5,0,0,0-1.061,2.561l5.3,5.3a2,2,0,0,0,2.828,0l5.3-5.3A1.5,1.5,0,0,0,29.648,25Z"
            opacity="0.05"
          />
          <path
            id="Trazado_4"
            data-name="Trazado 4"
            d="M29.393,26H26V18a1,1,0,0,0-1-1H23a1,1,0,0,0-1,1v8H18.607a.605.605,0,0,0-.428,1.034L23.143,32a1.213,1.213,0,0,0,1.714,0l4.964-4.964A.605.605,0,0,0,29.393,26Z"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
  );
};

export default IncloudIcon;

